'use client';





interface HeaderProps {
  className?: string;
  onContactSalesClick?: () => void;
}

const Header = ({ className = '', onContactSalesClick }: HeaderProps) => {
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-card shadow-md ${className}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo Section */}
          <div className="flex items-center space-x-3 group">
            <div className="relative">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="transition-transform duration-300 group-hover:scale-105">

                <rect width="40" height="40" rx="8" fill="url(#gradient)" />
                <path
                  d="M20 8L28 14V26L20 32L12 26V14L20 8Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round" />

                <path
                  d="M20 14L24 17V23L20 26L16 23V17L20 14Z"
                  fill="white"
                  opacity="0.8" />

                <circle cx="20" cy="20" r="2" fill="white" />
                <defs>
                  <linearGradient
                    id="gradient"
                    x1="0"
                    y1="0"
                    x2="40"
                    y2="40"
                    gradientUnits="userSpaceOnUse">

                    <stop stopColor="#1B365D" />
                    <stop offset="1" stopColor="#4A90A4" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="flex flex-col">
              <span className="font-display font-bold text-xl text-primary leading-none">
                UnifyMax
              </span>
              <span className="font-body text-xs text-muted-foreground leading-none mt-0.5">
                Enterprise
              </span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center space-x-3">
            <button
              onClick={onContactSalesClick}
              className="px-5 py-2 rounded-md font-cta text-sm bg-conversion text-conversion-foreground hover:shadow-cta transition-all duration-300 flex items-center">
              <span className="inline-flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                  <path d="M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 0 0-1.032-.211 50.89 50.89 0 0 0-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 0 0 2.433 3.984L7.28 21.53A.75.75 0 0 1 6 21v-4.03a48.527 48.527 0 0 1-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979Z" />
                  <path d="M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 0 0 1.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0 0 15.75 7.5Z" />
                </svg>
                Contact Sales
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>);

};

export default Header;